import React from 'react';
import c from 'classnames';

import type { SearchAllContentHit } from '../../types';
import ColleagueHit from './Colleague';
import FaqHit from './Faq';
import GenericHit from './Generic';

export interface SearchAllContentResultsHitProps {
  hit: SearchAllContentHit;
}

const SearchAllContentResultsHit: React.FC<SearchAllContentResultsHitProps> = ({ hit }) => {
  const classNames = c('SearchAllContent__Results__Hit');

  if (hit.colleague_full_name) {
    return <ColleagueHit hit={hit} className={classNames} />;
  }

  if (hit.type?.[0] === 'faq') {
    return <FaqHit hit={hit} className={classNames} />;
  }

  return <GenericHit hit={hit} className={classNames} />;
};

export default SearchAllContentResultsHit;
